import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default class SliderImg {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const isProjet = this.el.dataset.mode === 'projets'

    new Swiper(this.el.querySelector('.slider-img--swiper'), {
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      spaceBetween: 16,
      slidesOffsetBefore: 10,
      slidesOffsetAfter: 10,
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
      },
      navigation: {
        prevEl: this.el.querySelector('.slider-img--prev'),
        nextEl: this.el.querySelector('.slider-img--next'),
      },
      breakpoints: {
        992: {
          slidesPerView: isProjet ? 2.8 : 3,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    })
  }
}
